// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__rPFkV","inputDescription":"styles_inputDescription__30PST"};